import { css } from '@emotion/core'

export const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  content: css`
    width: calc(100% - 18px);
    padding: 11px 8px 8px 8px;

    background: white;
    border-radius: 3px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.01), 0 10px 7px rgba(0, 0, 0, 0.005);
    z-index: -10;

    margin-top: -16px;
    margin-bottom: 18px;

    display: flex;
    flex-direction: row;
  `,

  section: css`
    flex: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 12px;
    color: rgb(130, 130, 130);
  `,

  status: {
    pending: css``,
    accepted: css`
      /* color: rgba(58, 137, 196, 0.85); */
      color: rgba(16, 172, 132, 0.85);
    `,
  },
}
